import { useDisciplineScheduleStore } from './schedule/store'
import { useDisciplineScheduleAllocationResultsApi } from '../api/schedule-allocation-results.hook'

interface DisciplineScheduleResultsReturn {
  loadResults: (activationRunId: number) => Promise<void>
}

/** Reads a run's candidate tutors; an answer for a run the admin has left behind is dropped. */
export const useDisciplineScheduleResults = (): DisciplineScheduleResultsReturn => {
  const route = useRoute()
  const store = useDisciplineScheduleStore()

  const loadResults = async (activationRunId: number): Promise<void> => {
    const results = await useDisciplineScheduleAllocationResultsApi({
      disciplineId: route.params.id as string,
      activationRunId,
    })

    if (!results || store.getActivationRunId !== activationRunId) return

    store.setAllocationResults({
      allocationLogs: results.logs,
      allocationTutors: results.tutors,
    })
  }

  return {
    loadResults,
  }
}
